// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-screen {
  background: var(--welcome-bg);
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}
.welcome-screen .welcome-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
.welcome-screen .welcome-header ion-toolbar {
  --background: transparent;
  --color: var(--text-primary-dark);
}
.welcome-screen .welcome-header ion-toolbar .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--header-height);
}
.welcome-screen .welcome-header ion-toolbar .header-content .logo {
  font-size: var(--logo-font-size);
  font-weight: var(--font-weight-regular);
  color: var(--logo-color);
  font-family: var(--font-family-primary);
}
.welcome-screen .welcome-header ion-toolbar .header-content .menu-button {
  background: transparent;
  border: none;
  color: var(--menu-button-color);
  cursor: pointer;
  padding: var(--spacing-sm);
  border-radius: var(--border-radius-sm);
  transition: background-color 0.2s ease;
}
.welcome-screen .welcome-header ion-toolbar .header-content .menu-button:hover {
  background: rgba(255, 255, 255, 0.1);
}
.welcome-screen .welcome-header ion-toolbar .header-content .menu-button ion-icon {
  font-size: 24px;
}
.welcome-screen .welcome-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--spacing-2xl) var(--page-padding);
  gap: var(--spacing-2xl);
}
.welcome-screen .welcome-content .hero-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.welcome-screen .welcome-content .hero-image-container .hero-image {
  width: var(--hero-image-size);
  height: var(--hero-image-size);
  border-radius: var(--border-radius-full);
  object-fit: cover;
  box-shadow: var(--shadow-lg);
  transition: transform 0.3s ease;
}
.welcome-screen .welcome-content .hero-image-container .hero-image:hover {
  transform: scale(1.02);
}
.welcome-screen .welcome-content .hero-text {
  max-width: 600px;
}
.welcome-screen .welcome-content .hero-text h1 {
  color: var(--welcome-text-color);
  font-size: var(--welcome-hero-text-size);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-tight);
  margin: 0;
  letter-spacing: -0.02em;
}
@media (max-width: 768px) {
  .welcome-screen .welcome-content .hero-text h1 {
    font-size: 36px;
  }
}
@media (max-width: 480px) {
  .welcome-screen .welcome-content .hero-text h1 {
    font-size: 28px;
  }
}
.welcome-screen .welcome-content .cta-button {
  background: var(--welcome-cta-bg);
  color: var(--welcome-cta-color);
  padding: var(--spacing-lg) var(--spacing-3xl);
  border-radius: var(--border-radius-pill);
  font-size: var(--font-size-button-large);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-button);
  min-width: 280px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.welcome-screen .welcome-content .cta-button:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-button-hover);
}
.welcome-screen .welcome-content .cta-button:active {
  transform: translateY(0);
  box-shadow: var(--shadow-button);
}
@media (max-width: 480px) {
  .welcome-screen .welcome-content .cta-button {
    min-width: 240px;
    padding: var(--spacing-md) var(--spacing-xl);
    font-size: var(--font-size-button);
  }
}
.welcome-screen .language-toggle {
  position: absolute !important;
  bottom: var(--spacing-xl);
  left: 50% !important;
  transform: translateX(-50%) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-md);
  width: auto;
  margin: 0 !important;
  padding: 0 !important;
}
.welcome-screen .language-toggle .language-btn {
  width: 48px;
  height: 48px;
  border-radius: var(--border-radius-full);
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: var(--text-primary-dark);
  cursor: pointer;
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
  transition: all 0.2s ease;
}
.welcome-screen .language-toggle .language-btn:hover {
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.1);
}
.welcome-screen .language-toggle .language-btn.active {
  background: var(--button-primary);
  border-color: var(--button-primary);
  color: #ffffff;
}
.welcome-screen .language-toggle::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  pointer-events: none;
}
@media (min-width: 769px) {
  .welcome-screen .language-toggle {
    left: 50% !important;
    transform: translateX(-50%) !important;
    position: absolute !important;
  }
}
@media (max-width: 768px) {
  .welcome-screen .language-toggle {
    bottom: var(--spacing-lg);
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: auto;
  }
}
@media (max-width: 480px) {
  .welcome-screen .language-toggle {
    bottom: var(--spacing-md);
    gap: var(--spacing-sm);
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .welcome-screen .language-toggle .language-btn {
    width: 44px;
    height: 44px;
    font-size: var(--font-size-caption);
  }
}

@media (prefers-color-scheme: dark) {
  .welcome-screen .hero-image {
    box-shadow: var(--shadow-dark-lg);
  }
}
@keyframes welcomeFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.welcome-screen {
  animation: welcomeFadeIn 0.8s ease-out;
}

.hero-image-container .hero-image {
  animation: welcomeFadeIn 0.8s ease-out 0.2s both;
}

.hero-text {
  animation: welcomeFadeIn 0.8s ease-out 0.4s both;
}

.cta-button {
  animation: welcomeFadeIn 0.8s ease-out 0.6s both;
}

.language-toggle {
  animation: welcomeFadeIn 0.8s ease-out 0.8s both;
}`, "",{"version":3,"sources":["webpack://./src/app/components/welcome-screen/welcome-screen.component.scss"],"names":[],"mappings":"AAGA;EACE,6BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAKE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAHJ;AAKI;EACE,yBAAA;EACA,iCAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,4BAAA;AAJR;AAMQ;EACE,gCAAA;EACA,uCAAA;EACA,wBAAA;EACA,uCAAA;AAJV;AAOQ;EACE,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,0BAAA;EACA,sCAAA;EACA,sCAAA;AALV;AAOU;EACE,oCAAA;AALZ;AAQU;EACE,eAAA;AANZ;AAcE;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,+CAAA;EACA,uBAAA;AAZJ;AAcI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAZN;AAcM;EACE,6BAAA;EACA,8BAAA;EACA,wCAAA;EACA,iBAAA;EACA,4BAAA;EACA,+BAAA;AAZR;AAcQ;EACE,sBAAA;AAZV;AAiBI;EACE,gBAAA;AAfN;AAiBM;EACE,gCAAA;EACA,wCAAA;EACA,uCAAA;EACA,qCAAA;EACA,SAAA;EACA,uBAAA;AAfR;AAkBQ;EATF;IAUI,eAAA;EAfR;AACF;AAiBQ;EAbF;IAcI,eAAA;EAdR;AACF;AAkBI;EACE,iCAAA;EACA,+BAAA;EACA,6CAAA;EACA,wCAAA;EACA,wCAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAhBN;AAkBM;EACE,2BAAA;EACA,sCAAA;AAhBR;AAmBM;EACE,wBAAA;EACA,gCAAA;AAjBR;AAqBM;EA1BF;IA2BI,gBAAA;IACA,4CAAA;IACA,kCAAA;EAlBN;AACF;AAuBE;EACE,6BAAA;EACA,yBAAA;EACA,oBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,0CAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,kCAAA;EACA,sCAAA;EACA,yBAAA;AArBN;AAuBM;EACE,sCAAA;EACA,oCAAA;AArBR;AAwBM;EACE,iCAAA;EACA,mCAAA;EACA,cAAA;AAtBR;AA2BI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;AAzBN;AA6BI;EA/CF;IAgDI,oBAAA;IACA,sCAAA;IACA,6BAAA;EA1BJ;AACF;AA6BI;EAtDF;IAuDI,yBAAA;IACA,oBAAA;IACA,sCAAA;IACA,WAAA;EA1BJ;AACF;AA4BI;EA7DF;IA8DI,yBAAA;IACA,sBAAA;IACA,oBAAA;IACA,sCAAA;EAzBJ;EA2BI;IACE,WAAA;IACA,YAAA;IACA,mCAAA;EAzBN;AACF;;AA+BA;EAEI;IACE,iCAAA;EA7BJ;AACF;AAkCA;EACE;IACE,UAAA;IACA,2BAAA;EAhCF;EAkCA;IACE,UAAA;IACA,wBAAA;EAhCF;AACF;AAmCA;EACE,sCAAA;AAjCF;;AAoCA;EACE,gDAAA;AAjCF;;AAoCA;EACE,gDAAA;AAjCF;;AAoCA;EACE,gDAAA;AAjCF;;AAoCA;EACE,gDAAA;AAjCF","sourcesContent":["// Welcome Screen Component Styles\n// Based on \"Die Welt von Reishauer\" design\n\n.welcome-screen {\n  background: var(--welcome-bg);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n\n  // Header styling\n  .welcome-header {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 10;\n\n    ion-toolbar {\n      --background: transparent;\n      --color: var(--text-primary-dark);\n\n      .header-content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        // padding: var(--spacing-md) var(--page-padding);\n        height: var(--header-height);\n\n        .logo {\n          font-size: var(--logo-font-size);\n          font-weight: var(--font-weight-regular);\n          color: var(--logo-color);\n          font-family: var(--font-family-primary);\n        }\n\n        .menu-button {\n          background: transparent;\n          border: none;\n          color: var(--menu-button-color);\n          cursor: pointer;\n          padding: var(--spacing-sm);\n          border-radius: var(--border-radius-sm);\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background: rgba(255, 255, 255, 0.1);\n          }\n\n          ion-icon {\n            font-size: 24px;\n          }\n        }\n      }\n    }\n  }\n\n  // Main content area\n  .welcome-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: var(--spacing-2xl) var(--page-padding);\n    gap: var(--spacing-2xl);\n\n    .hero-image-container {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .hero-image {\n        width: var(--hero-image-size);\n        height: var(--hero-image-size);\n        border-radius: var(--border-radius-full);\n        object-fit: cover;\n        box-shadow: var(--shadow-lg);\n        transition: transform 0.3s ease;\n\n        &:hover {\n          transform: scale(1.02);\n        }\n      }\n    }\n\n    .hero-text {\n      max-width: 600px;\n\n      h1 {\n        color: var(--welcome-text-color);\n        font-size: var(--welcome-hero-text-size);\n        font-weight: var(--font-weight-regular);\n        line-height: var(--line-height-tight);\n        margin: 0;\n        letter-spacing: -0.02em;\n\n        // Responsive text sizing\n        @media (max-width: 768px) {\n          font-size: 36px;\n        }\n\n        @media (max-width: 480px) {\n          font-size: 28px;\n        }\n      }\n    }\n\n    .cta-button {\n      background: var(--welcome-cta-bg);\n      color: var(--welcome-cta-color);\n      padding: var(--spacing-lg) var(--spacing-3xl);\n      border-radius: var(--border-radius-pill);\n      font-size: var(--font-size-button-large);\n      font-weight: var(--font-weight-medium);\n      border: none;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      box-shadow: var(--shadow-button);\n      min-width: 280px;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n\n      &:hover {\n        transform: translateY(-2px);\n        box-shadow: var(--shadow-button-hover);\n      }\n\n      &:active {\n        transform: translateY(0);\n        box-shadow: var(--shadow-button);\n      }\n\n      // Responsive button sizing\n      @media (max-width: 480px) {\n        min-width: 240px;\n        padding: var(--spacing-md) var(--spacing-xl);\n        font-size: var(--font-size-button);\n      }\n    }\n  }\n\n  // Language toggle at bottom\n  .language-toggle {\n    position: absolute !important;\n    bottom: var(--spacing-xl);\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: var(--spacing-md);\n    width: auto;\n    margin: 0 !important;\n    padding: 0 !important;\n\n    .language-btn {\n      width: 48px;\n      height: 48px;\n      border-radius: var(--border-radius-full);\n      border: 2px solid rgba(255, 255, 255, 0.3);\n      background: transparent;\n      color: var(--text-primary-dark);\n      cursor: pointer;\n      font-size: var(--font-size-button);\n      font-weight: var(--font-weight-medium);\n      transition: all 0.2s ease;\n\n      &:hover {\n        border-color: rgba(255, 255, 255, 0.6);\n        background: rgba(255, 255, 255, 0.1);\n      }\n\n      &.active {\n        background: var(--button-primary);\n        border-color: var(--button-primary);\n        color: #ffffff;\n      }\n    }\n\n    // Alternative centering approach for better compatibility\n    &::before {\n      content: '';\n      position: absolute;\n      left: 0;\n      right: 0;\n      pointer-events: none;\n    }\n\n    // Desktop centering\n    @media (min-width: 769px) {\n      left: 50% !important;\n      transform: translateX(-50%) !important;\n      position: absolute !important;\n    }\n\n    // Tablet centering\n    @media (max-width: 768px) {\n      bottom: var(--spacing-lg);\n      left: 50% !important;\n      transform: translateX(-50%) !important;\n      width: auto;\n    }\n\n    @media (max-width: 480px) {\n      bottom: var(--spacing-md);\n      gap: var(--spacing-sm);\n      left: 50% !important;\n      transform: translateX(-50%) !important;\n      \n      .language-btn {\n        width: 44px;\n        height: 44px;\n        font-size: var(--font-size-caption);\n      }\n    }\n  }\n}\n\n// Dark theme specific adjustments\n@media (prefers-color-scheme: dark) {\n  .welcome-screen {\n    .hero-image {\n      box-shadow: var(--shadow-dark-lg);\n    }\n  }\n}\n\n// Animation for smooth entrance\n@keyframes welcomeFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.welcome-screen {\n  animation: welcomeFadeIn 0.8s ease-out;\n}\n\n.hero-image-container .hero-image {\n  animation: welcomeFadeIn 0.8s ease-out 0.2s both;\n}\n\n.hero-text {\n  animation: welcomeFadeIn 0.8s ease-out 0.4s both;\n}\n\n.cta-button {\n  animation: welcomeFadeIn 0.8s ease-out 0.6s both;\n}\n\n.language-toggle {\n  animation: welcomeFadeIn 0.8s ease-out 0.8s both;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
